import React from "react";

import CallToAction from "PayrollLead/CallToAction";
import Chrome from "PayrollLead/Chrome";
import { createStore } from "PayrollLead/redux";
import { Provider } from "react-redux";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { BasicLoading } from "ZeroRuby";

import PartnerProvider from "Common/PartnerProvider";
import { useSiteConfig } from "Common/Redux/siteConfig";
import ScrollToTop from "Common/ScrollToTop";

const LoadingPage = () => (
  <Chrome>
    <BasicLoading />
  </Chrome>
);

const PayrollLeadApp = () => {
  const match = useRouteMatch();
  const { isLoading: isLoadingSiteConfig, data: _siteConfig } = useSiteConfig();

  return isLoadingSiteConfig ? (
    <LoadingPage />
  ) : (
    <ScrollToTop>
      <PartnerProvider>
        <Chrome title="Company Selection">
          <Switch>
            <Route path={`${match.url}`} children={<CallToAction />} />
          </Switch>
        </Chrome>
      </PartnerProvider>
    </ScrollToTop>
  );
};

class App extends React.Component {
  constructor() {
    super();
    this.store = createStore();
  }

  render() {
    return (
      <Provider store={this.store}>
        <PayrollLeadApp />
      </Provider>
    );
  }
}

export default App;
